export default "__VITE_ASSET__rX2p0ozn__"